import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.orders.title" 
      icon="construction"
      >
    </app-placeholder-page>
  `
})
export class OrdersComponent {}